import styled from '@emotion/styled';
import { css } from '@emotion/react';

const tooltipTop = (props) =>
    props.top &&
    css`
        padding: 10px 0;
    `;

const tooltipLeft = (props) =>
    props.left &&
    css`
        padding: 0 10px;
    `;

const tooltipActive = (props) =>
    props.active
        ? css`
              opacity: 1;
              z-index: 10000;
          `
        : css`
              opacity: 0;
              z-index: -1;
          `;

export const Tooltip = styled.div`
    position: fixed;
    font-size: 12px;
    pointer-events: none;
    ${tooltipTop};
    ${tooltipLeft};
    ${tooltipActive};
`;

const tooltipArrowRight = (props) =>
    props.right &&
    css`
        left: 0;
        width: 10px;
        height: 100%;
        top: 28%;
        &::before {
            right: -1px;
            border-width: 10px 10px 10px 0;
            border-right-color: ${props.theme.color.gray3};
        }
        &::after {
            right: -1px;
            top: 1px;
            border-width: 9px 9px 9px 0;
            border-top-color: ${props.theme.color.black};
        }
    `;

const tooltipArrowLeft = (props) =>
    props.left &&
    css`
        right: 0;
        width: 10px;
        height: 100%;
        top: 28%;
        &::before {
            left: -1px;
            border-width: 10px 0 10px 10px;
            border-left-color: ${props.theme.color.gray3};
        }
        &::after {
            left: -1px;
            top: 1px;
            border-width: 9px 9px 9px 0;
            border-top-color: ${props.theme.color.black};
        }
    `;

const tooltipArrowTop = (props) =>
    props.top &&
    css`
        bottom: 0;
        width: 100%;
        left: ${Math.max(props.arrowPosFromLeft, 1)}%;
        &::before {
            top: -1px;
            border-width: 10px 10px 0;
            border-top-color: ${props.theme.color.gray3};
        }
        &::after {
            top: -1px;
            left: 1px;
            border-width: 9px 9px 0;
            border-top-color: ${props.theme.color.black};
        }
    `;
const tooltipArrowBottom = (props) =>
    props.bottom &&
    css`
        top: 0;
        width: 100%;
        left: ${Math.max(props.arrowPosFromLeft, 1)}%;
        &::before {
            bottom: -1px;
            border-width: 0 10px 10px;
            border-bottom-color: ${props.theme.color.gray3};
        }
        &::after {
            bottom: -1px;
            left: 1px;
            border-width: 0 9px 9px;
            border-bottom-color: ${props.theme.color.black};
        }
    `;

export const TooltipArrow = styled.div`
    position: absolute;
    display: block;
    width: 8px;
    height: 10px;
    &::before,
    &::after {
        position: absolute;
        content: '';
        border-color: transparent;
        border-style: solid;
    }
    ${tooltipArrowTop};
    ${tooltipArrowRight};
    ${tooltipArrowBottom};
    ${tooltipArrowLeft};
`;

export const TooltipInner = styled.div`
    padding: 10px;
    text-align: center;
    ${(p) => css`
        background-color: ${p.theme.color.black};
        border: 1px solid ${p.theme.color.gray3};
        border-radius: ${p.theme.borderRadius.medium};
    `};
`;
